<template>
  <div :class="$style.container">
    <component :is="component" v-bind="{ blogId }" />
  </div>
</template>

<script>
import BlogPostList from './BlogPostList'
import BlogCreatePost from './BlogCreatePost'

export default {
  name: 'blog-view',
  components: {
    BlogPostList,
    BlogCreatePost
  },
  props: {
    blogId: String
  },
  computed: {
    isCreatePost () {
      return !!this.$route.query.isCreatePost
    },
    component () {
      return this.isCreatePost ? BlogCreatePost : BlogPostList
    }
  }
}
</script>

<style module lang="scss">
.container {
  padding: 8px 20px;
  overflow-x: hidden;
  overflow-y: scroll;
  flex: 1;
}
</style>
